import type { EnvSettings } from './index'

export const messageCentreEnvSettings: EnvSettings = {
  master: true,
  staging: true,
  production: false,
}
